import { Component } from '@angular/core';
import { AlertService } from '../services/alert.service';
import { ReportsService } from '../reports/reports.service';
import { AuthService } from '../auth/authservice.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
    styleUrls: ['./auth.component.scss'],
    templateUrl: './auth.component.html'
})
export class AuthComponent {
    title: string = "Manage Authorizations";
    modalProps = {
        state: false,
        backdrop: true,
        title: "Delete Configuration",
        bodyContent: this.translateService.instant('admin.EnableRelMsg'),
        cancelButton: this.translateService.instant('cancel'),
        okButton: this.translateService.instant('adminGridOption.delete"'),
        cancelBClass: "btn-outline",
        okBClass: "btn-danger"
    };
    authorizations = [
        {
            value: "Approval/Sign-off"
        },
        {
            value: "Assign maximum owners"
        },
        {
            value: "Publish"
        },
        {
            value: "Read-only access"
        },
        {
            value: "Add new version"
        },
        {
            value: "Preview"
        },
        {
            value: "Manage users"
        },
        {
            value: "Add limits"
        },
        {
            value: "View groups"
        },
        {
            value: "Add new maximum"
        },
        {
            value: "Manage groups"
        },
        {
            value: "Edit published limits"
        },
        {
            value: "View users"
        },
        {
            value: "Delete published maximum"
        }
    ];
    constructor(private alertService: AlertService,
        private reportService: ReportsService,
        private authService: AuthService,
        private translateService: TranslateService) {
    }
    launchModal(event) {
        let btnId = event.target.id;
        switch (btnId) {
            case "saveBtn":
                this.modalProps.title = "Save Confirmation";
                this.modalProps.bodyContent = this.translateService.instant('admin.EnableRelMsg');
                this.modalProps.okButton = this.translateService.instant('save');
                this.modalProps.cancelButton = this.translateService.instant('cancel');
                this.modalProps.cancelBClass = "btn-outline";
                this.modalProps.okBClass = "btn-success";
                break;
        }
        this.modalProps.state = true;
    }
    modalHandler(btnOutput: boolean) {
        if (btnOutput) {
            this.alertService.success(this.modalProps.title + " - Succesful");
            window.setTimeout(() => this.alertService.clear(), 3000);
        } else {
            this.alertService.warn(this.modalProps.title + this.translateService.instant('revertAlertLabel'));
            window.setTimeout(() => this.alertService.clear(), 3000);
        }
    }

    getUserRoleDetails(): void {
        this.authService.getUserRoleDetails() // Get all product release versions of a given product
            .subscribe(vmwareproductsVersions => {
                this.reportService.selectedversions = vmwareproductsVersions;
            },
                err => {
                    console.log(err)
                });

    }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.component.ts